module.exports = __webpack_public_path__ + "static/media/3d-asap.f27cf6d2.webm";